import PropTypes from 'prop-types';
import React from 'react';

import Button from '../../shared/SecondaryButton/SecondaryButton';
import WorkPlaceRetirementLink from "../WorkPlaceRetirement/WorkPlaceRetirementLink";
import styles from './SentZeroState.module.scss';

const SentZeroState = ({ hasTracOnly, transition = () => {} }) => {
  return (
    <div className={styles.container}>
      <h3 className={styles.title} id="zero-state-title">
        You have no sent messages.
      </h3>
      {hasTracOnly ? (
        <WorkPlaceRetirementLink />
      ) : (
        <Button
          className={styles['zero-state-button']}
          id="create-message-zero-state"
          onClick={() => transition('compose')}
        >
          Create a new message
        </Button>
      )}

      <p className={styles['more-info']}>
        Or, for general questions and answers, please visit our{' '}
        <a
          className={styles.link}
          href={
            'https://www.troweprice.com/personal-investing/help/account-information.html'
          }
          id="help-center"
          rel="noopener noreferrer"
          target="_blank"
        >
          Help Center
        </a>
        .
      </p>
    </div>
  );
};

SentZeroState.propTypes = {
  hasTracOnly: PropTypes.bool,
  transition: PropTypes.func
};

export default SentZeroState;
